"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getBinarySoundHeaders_1 = __importDefault(require("../getBinarySoundHeaders"));
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Updates the metadata of one or more sound file(s)
 * The fields that are not supplied remain unchanged
 * Only language, labels, transcript, and category can be edited at this time
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param soundIds An array of sound IDs to update
 * @param metadata An object of metadata fields to update
 */
function updateSoundMetadata(baseUrl, wardenToken, soundIds, metadata) {
    return (0, http_client_1.default)({
        method: "PUT",
        url: baseUrl + "/v0/media/sound/metadata",
        headers: __assign({}, (0, getBinarySoundHeaders_1.default)(wardenToken)),
        data: __assign({ soundIds: soundIds }, metadata)
    }).then(function (response) { return response.data; });
}
exports.default = updateSoundMetadata;
